export default {"src":"/_next/static/media/bikepolo.d981c2fc.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};